<form [formGroup]="form" (ngSubmit)="enviar()" *ngIf="!carregando">
  <div class="form-group mb-4 bg-white">
    <label>Faça o upload do arquivo</label>
  </div>
  <div class="mb-4 container-fluid">
    <div class="row">
        <div class="d-block">
          <input hidden (change)="uploadArquivo($event)" #fileInput type="file" id="file"
                 accept=".png,.jpg,.jpeg,.pdf"
                 [ngClass]="{'is-invalid':
               !validarFormulario && fc?.extensaoArquivo?.invalid && nomeArquivo ||
                fc?.base64?.errors?.fileSizeExceeded && nomeArquivo ||
                fc?.extensaoArquivo?.invalid && nomeArquivo ||
               fc.base64.invalid && !validarFormulario}">
          <div class="invalid-feedback">
            <span *ngIf="fc?.extensaoArquivo?.invalid && nomeArquivo">O documento enviado não está em um dos formatos aceitos (PDF, JPG, JPEG, PNG).</span>
            <span *ngIf="fc?.base64?.errors?.fileSizeExceeded && nomeArquivo">O documento excede o tamanho máximo permitido de 200 MB.</span>
            <span *ngIf="!validarFormulario && fc?.base64?.errors?.required && !nomeArquivo">Campo obrigatório</span>
          </div>
        </div>
    </div>
  </div>
</form>
